export const environment = {
  production: false,
  name: 'dev',
  secretbKey: "47921864973276484792186497327648",
  modulePk:'01GG830F6B96A7R45T24Y08VF5:module',
  moduleSk:'01GG830F6BYHGEHVPRZDRA5V56:current',
  accessControlAPI:'https://access-control-v6.mango-api-dev.com/v1',
  firebaseConfig: {
    apiKey: "AIzaSyDT2SkQCJ6tOm6KamElGpmdaGEB4LC3ZA8",
    authDomain: "mango-forms-dev.firebaseapp.com",
    projectId: "mango-forms-dev",
    storageBucket: "mango-forms-dev.appspot.com",
    messagingSenderId: "1066590893749",
    appId: "1:1066590893749:web:169459eed7bf036672f0fc",
    measurementId: "G-2VPS1EPQ1Z"
  }
};
